<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <div v-if="value.length > 1" class="text-xs-right acao-expandir-recolher">
            <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-down</v-icon>
                Expandir Todos
            </v-btn>
            <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-up</v-icon>
                Recolher Todos
            </v-btn>
        </div>

        <v-expansion-panel v-model="paineis" expand class="painel-itens" :class="{ 'mt-3': value.length < 2}">
            <v-expansion-panel-content v-for="lote in value" :key="lote.id" class="painel-itens__linha cabecalho-painel">
                <template v-slot:header>
                    <p>
                        <strong> {{lote.sequencia}} - {{ lote.descricao }}</strong>
                    </p>
                </template>

                <painel-lote-legado-tabela
                    :itens="lote.itens"
                    :possuiValorReferencia="possuiValorReferencia"
                    :prefixOuSuffixValor="prefixOuSuffixValorCurrency"
                    :criterioJulgamento="criterioJulgamentoDaCompra"
                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                    :casasDecimais="casasDecimais"
                    :casasDecimaisQuantidade="casasDecimaisQuantidade"/>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-flex>
</template>

<script>
import PainelLoteLegadoTabela from './PainelLoteLegadoTabela'

export default {
    name: 'PainelLoteLegado',
    components: {
        PainelLoteLegadoTabela
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento: {
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        possuiValorReferencia:{
            type: Boolean
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            paineis: [],
            totalmenteExpandido: false,
            totalmenteRecolhido: true,
            ultimoEstadoPaineis: 'recolhido',
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(lote => {
                if (lote.totalGeral > 0) {
                    total += lote.totalGeral
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        prefixOuSuffixValorCurrency(){
            return this.prefixOuSuffixValor
        }
    },
    mounted() {
        this.expandirTodos()
    },
    methods: {
        recolherTodos() {
            this.paineis = this.value.map(() => {
                return false
            })
            this.totalmenteExpandido = false
        },
        expandirTodos() {
            this.paineis = this.value.map(() => {
                return true
            })
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        }
    },
    watch: {
        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style scoped lang="stylus">
.painel-itens__info
    margin-right 20px

@media (max-width 720px)
    .painel-itens__info
        margin-right 10px
</style>
